import { render, staticRenderFns } from "./AforoDoor.vue?vue&type=template&id=1317f6d2&"
import script from "./AforoDoor.vue?vue&type=script&lang=js&"
export * from "./AforoDoor.vue?vue&type=script&lang=js&"
import style0 from "./AforoDoor.vue?vue&type=style&index=0&id=1317f6d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports